import { render, staticRenderFns } from "./Action_mail.vue?vue&type=template&id=11155209&scoped=true"
import script from "./Action_mail.vue?vue&type=script&lang=js"
export * from "./Action_mail.vue?vue&type=script&lang=js"
import style0 from "./Action_mail.vue?vue&type=style&index=0&id=11155209&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11155209",
  null
  
)

export default component.exports